import axios from "axios";
import { API_HOST } from "@/core/variables";
import { AutoCompleteCreate, AutoCompleteUpdate } from "@/model";

class AutoCompleteRepository {
    find = async (agentId: number, page: number, size: number, keyword?: string, searchType?: string) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/autocompletes`, {
                params: {
                    agent_id: agentId,
                    page: page,
                    size: size,
                    keyword: keyword,
                    search_type: searchType
                }
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    read = async (agentId: number, autocompleteId: string) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}`)
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    create = async (agentId: number, form: AutoCompleteCreate) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/autocompletes`, {
                ...form,
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    update = async (agentId: number, autocompleteId: string, form: AutoCompleteUpdate) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}`, {
                ...form,
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete = async (agentId: number, autocompleteId: string) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}`)
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string, searchType?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => {
            params.append("ids", id);
        });
        if (keyword) {
            params.append("keyword", keyword);
        }
        if (searchType) {
            params.append("search_type", searchType);
        }

        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/autocompletes`, {
                params: params
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
}



const autocompleteRepository = new AutoCompleteRepository();

export default autocompleteRepository;